import { Calendar, momentLocalizer } from "react-big-calendar"
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import moment from "moment"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useHistory } from "react-router-dom"
import { confirmDialog } from "primereact/confirmdialog"
import api from "../../../api"
import query from "../../../function/query"
import { useDebounce } from "../../../hook/useDebounce"
import { InputText } from "primereact/inputtext"
import styles from "./styles.module.css"
import "moment/locale/cs"
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { Calendar as PCalendar } from "primereact/calendar"
import { ProgressSpinner } from "primereact/progressspinner"
import { Dropdown } from "primereact/dropdown"
import getPreventionStateSeverity from "../../../function/getPreventionStateSeverity"
import UserMultiFilter from "../../../filter/UserMultiFilter"
import TaskTagMultiFilter from "../../../filter/TaskTagMultiFilter"
import MachineMultiFilter from "../../../filter/MachineMultiFilter"

const mLocalizer = momentLocalizer(moment)
const cultures = ['cs']
const lang = {
  "cs": {
    week: 'Týden',
    work_week: 'Pracovní týden',
    day: 'Den',
    month: 'Měsíc',
    previous: 'Předchozí',
    next: 'Následující',
    today: 'Dnes',
    agenda: 'Agenda',
    showMore: (total) => `+${total} dalších`,
  }
}
const style = {
  width: "100%",
  minHeight: "calc(100vh - 200px)",
}

const DnDCalendar = withDragAndDrop(Calendar)

export default function TaskCalendar() {
  const history = useHistory()

  const [date, setDate] = useState(new Date())
  const [view, setView] = useState("week")
  const [events, setEvents] = useState([])
  const defaultDate = useMemo(() => new Date(), [])
  const handleDateChange = (event) => setDate(event.value)

  const [loading, setLoading] = useState(false)
  const [selectedSlot, setSelectedSlot] = useState(null)
  const [isNewTaskDialogOpen, setIsNewTaskDialogOpen] = useState(false)
  const [refresher, setRefresher] = useState(false)

  console.log(mLocalizer.firstVisibleDay(date), mLocalizer.lastVisibleDay(date))

  const [task, setTask] = useState("")
  const handleTaskChange = (event) => setTask(event.value)
  const taskOptions = [
    { label: "Všechny úkoly", value: "" },
    { label: "Pravidelná údržba", value: "PREVENTION" },
    { label: "Hlášení", value: "REPORT" },
  ]

  const [fulltext, setFulltext] = useState("")
  const handleFulltextChange = (e) => setFulltext(e.target.value)
  const fulltextDebounced = useDebounce(fulltext, 500)

  const [user, setUser] = useState([])
  const handleUserChange = (e) => setUser(e.target.value || [])

  const [tag, setTag] = useState([])
  const handleTagChange = (e) => setTag(e.target.value || [])

  const [machine, setMachine] = useState([])
  const handleMachineChange = (e) => setMachine(e.target.value || [])

  const onNewTaskDialogHide = () => {
    setSelectedSlot(null)
    setIsNewTaskDialogOpen(false)
  }

  useEffect(() => {
    setLoading(true)

    let params = {
      starts_at: view === "month"
        ? moment(mLocalizer.firstVisibleDay(date)).format("YYYY-MM-DD")
        : moment(date).startOf(view).format("YYYY-MM-DD"),
      ends_at: view === "month"
        ? moment(mLocalizer.lastVisibleDay(date)).format("YYYY-MM-DD")
        : moment(date).endOf(view).format("YYYY-MM-DD"),
    }

    if (task) {
      params.type = task
    }

    if (fulltextDebounced) {
      params.fulltext = fulltextDebounced
    }

    if (user.length) {
      params.user = user
    }

    if (tag.length) {
      params.tag = tag
    }

    if (machine.length) {
      params.machine = machine
    }

    api.get(`/tasks/events${query.toString(params)}`)
      .then(({ data }) => {
        const newEvents = data.data.map((item) => {
          return {
            id: item.uuid,
            title: item.title,
            start: moment(item.starts_at).toDate(),
            end: moment(item.ends_at).toDate(),
            type: item.type,
            tag: item.tag,
            state: item.state,
          }
        })
        setEvents(newEvents)
      }).finally(() => {
        setLoading(false)
      })
  }, [date, view, task, user, tag, machine, fulltextDebounced, refresher])

  const onNavigate = (newDate, view, action) => {
    setDate(newDate)
  }

  const onView = (view) => {
    setView(view)
  }

  const onSelectEvent = useCallback((event) => {
    if (event.id === null) {
      return
    }
    if (event.type === "PREVENTION") {
      history.push(`/task/prevention/${event.id}/subtasks`)
    } else {
      history.push(`/task/report/${event.id}/detail`)
    }
  }, [history])

  const onSelectSlot = useCallback((slot) => {
    setSelectedSlot(slot)
    setIsNewTaskDialogOpen(true)
  }, [])

  const onCreateNewTask = useCallback((type) => {
    if (type === "PREVENTION") {
      if (selectedSlot) {
        history.push(`/task/prevention?starts_at=${moment(selectedSlot.start).toISOString()}`)
      } else {
        history.push(`/task/prevention`)
      }
    } else {
      if (selectedSlot) {
        history.push(`/task/report?starts_at=${moment(selectedSlot.start).toISOString()}&ends_at=${moment(selectedSlot.end).toISOString()}`)
      } else {
        history.push(`/task/report`)
      }
    }
    setSelectedSlot(null)
    setIsNewTaskDialogOpen(false)
  }, [history, selectedSlot])

  const onEventDrop = useCallback(({ event, start }) => {
    const savePrevention = async () => {
      const { data } = await api.get(`/tasks/${event.id}`)
      const prevention = data.data

      await api.patch(`/tasks/${event.id}/close`, {})

      const payload = {
        type: "PREVENTION",
        operation: prevention.operation.uuid,
        name: prevention.name,
        description: prevention.description,
        repeated: prevention.repeated,
        team: prevention.team.uuid,
        machine: prevention.machine.uuid,
        starts_at: moment(start).startOf("day").toISOString(),
        order: prevention.order,
        tasks: prevention.tasks.map((task) => {
          let newTask = Object.assign({}, task)

          if (newTask.value_min === null) {
            delete newTask.value_min
          }

          if (newTask.value_max === null) {
            delete newTask.value_max
          }

          newTask.files = newTask.files.map((file) => {
            const newFile = Object.assign({}, file)

            if (!newFile.url) {
              delete newFile.uuid
            }

            return newFile
          })

          return newTask
        }),
      }

      if (prevention.repeated_value) {
        payload.repeated_value = prevention.repeated_value
      }

      if (prevention.user) {
        payload.user = prevention.user.uuid
      }

      payload.files = prevention.files.map((file) => {
        const newFile = Object.assign({}, file)

        if (!newFile.url) {
          delete newFile.uuid
        }

        return newFile
      })

      api
        .put("/tasks", payload)
        .then(() => setRefresher(!refresher))
    }

    const saveNewPrevention = async () => {
      const { data } = await api.get(`/tasks/${event.id}`)
      const prevention = data.data

      const payload = {
        type: "PREVENTION",
        operation: prevention.operation.uuid,
        name: prevention.name,
        description: prevention.description,
        repeated: prevention.repeated,
        repeated_value: prevention.repeatedValue,
        team: prevention.team.uuid,
        machine: prevention.machine.uuid,
        starts_at: moment(start).startOf("day").toISOString(),
        order: prevention.order,
        tasks: prevention.tasks.map((subTask) => {
          let newSubTask = Object.assign({}, subTask)

          if (newSubTask.value_min === null) {
            delete newSubTask.value_min
          }

          if (newSubTask.value_max === null) {
            delete newSubTask.value_max
          }

          newSubTask.files = newSubTask.files.map((subTaskFile) => {
            const newSubTaskFile = Object.assign({}, subTaskFile)

            if (!newSubTaskFile.url) {
              delete newSubTaskFile.uuid
            }

            return newSubTaskFile
          })

          return newSubTask
        }),
      }

      // cloning does not preserve files. request from customer...
      payload.files = []

      if (prevention.user) {
        payload.user = prevention.user.uuid
      }

      api
        .put("/tasks", payload)
        .then(() => setRefresher(!refresher))
    }

    const saveReport = async () => {
      const { data } = await api.get(`/tasks/${event.id}`)
      const report = data.data

      const payload = {
        uuid: report.uuid,
        type: "REPORT",
        state: report.state,
        name: report.name,
        description: report.description,
        machine: report.machine.uuid,
        tag: report.tag.uuid,
        order: report.order,
        starts_at: moment(start).toISOString(),
        ends_at: moment(start).add("1", "hour").toISOString(),
      }

      if (report.operation) {
        payload.operation = report.operation.uuid
      }

      if (report.team) {
        payload.team = report.team.uuid
      }

      if (report.user) {
        payload.user = report.user.uuid
      }

      if (report.note) {
        payload.note = report.note
      }

      api.post(`/tasks/${report.uuid}`, payload)
        .then(() => setRefresher(!refresher))
    }
    const saveNewReport = async () => {
      const { data } = await api.get(`/tasks/${event.id}`)
      const report = data.data

      const payload = {
        uuid: report.uuid,
        type: "REPORT",
        state: report.state,
        name: report.name,
        description: report.description,
        machine: report.machine.uuid,
        tag: report.tag.uuid,
        order: report.order,
        starts_at: moment(start).toISOString(),
        ends_at: moment(start).add("1", "hour").toISOString(),
      }

      if (report.operation) {
        payload.operation = report.operation.uuid
      }

      if (report.team) {
        payload.team = report.team.uuid
      }

      if (report.user) {
        payload.user = report.user.uuid
      }

      if (report.note) {
        payload.note = report.note
      }

      payload.files = report.files.map((file) => {
        const newfile = Object.assign({}, file)
        delete newfile.uuid
        return newfile
      })

      api.put("/tasks", payload)
        .then(() => setRefresher(!refresher))
    }

    if (event.type === "PREVENTION" && !event.id) {
      return alert("Nelze aktualizovat budoucí naplánovanou preventivní údržbu.")
    }

    confirmDialog({
      message: `Chcete aktualizovat ${event.type === "REPORT" ? "současné hlášení" : "současnou preventivní údržbu"} nebo vytvořit ${event.type === "REPORT" ? "nové" : "novou"}?`,
      header: `Opravdu přeplánovat ${event.type === "REPORT" ? "hlášení" : "preventivní údržbu"}?`,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      accept: event.type === "REPORT" ? saveNewReport : saveNewPrevention,
      reject: event.type === "REPORT" ? saveReport : savePrevention,
      acceptLabel: event.type === "REPORT" ? "Uložit nové" : "Uložit novou",
      rejectLabel: "Uložit",
      rejectClassName: "p-button-primary"
    })
  }, [refresher])

  const newTaskDialogFooter = () => (
    <div>
      <Button label="Hlášení" onClick={() => onCreateNewTask("REPORT")} />
      <Button label="Pravidelná údržba" onClick={() => onCreateNewTask("PREVENTION")} />
    </div>
  )

  const eventPropGetter = useCallback((
    event, start, end, isSelected
  ) => {
    let bgColor
    let className

    if (event.type === "REPORT" && event.tag && event.tag.color) {
      bgColor = event.tag.color
    }

    if (event.type === "PREVENTION") {
      className = getPreventionStateSeverity(event.state)
    }

    return {
      style: {
        color: bgColor ? "#000" : "#FFF",
        backgroundColor: bgColor
      },
      className,
    }
  }, [])

  const allDayAccessor = useCallback((event) => event.type === "PREVENTION", [])

  const tooltipAccessor = useCallback((event) => {
    return `${event.title}\n${moment(event.start).format("DD. MM. YYYY hh:mm")} - ${moment(event.end).format("DD. MM. YYYY hh:mm")}`
  }, [])

  return (
    <>
      {loading && (
        <div className={styles.loader}>
          <ProgressSpinner style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translateX(-50%) translateY(-50%)",
          }} />
        </div>
      )}
      <div className="col-12">
        <div className={styles.filters}>
          <div>
            <Button icon="pi pi-plus" className="p-button-outlined" label="Nový úkol"
              onClick={() => setIsNewTaskDialogOpen(true)} style={{ height: "100%" }} />
          </div>
          <div className={styles.filter}>
            <PCalendar value={date} onChange={handleDateChange} placeholder="Date" dateFormat="dd. mm. yy" />
          </div>
          <div className={styles.filter}>
            <Dropdown value={task} options={taskOptions} onChange={handleTaskChange} placeholder="Úkol" />
          </div>
          <div className={styles.filter}>
            <InputText value={fulltext} onChange={handleFulltextChange} placeholder="Fulltext" />
          </div>
          <div className={styles.filter}>
            <UserMultiFilter value={user} onChange={handleUserChange} placeholder={"Odpovědná osoba"} />
          </div>
          <div className={styles.filter}>
            <TaskTagMultiFilter value={tag} onChange={handleTagChange} />
          </div>
          <div className={styles.filter}>
            <MachineMultiFilter value={machine} onChange={handleMachineChange} />
          </div>
        </div>
      </div>

      <div className="col-12">
        <DnDCalendar
          selectable
          cultures={cultures}
          culture="cs"
          messages={lang["cs"]}
          lang={lang}
          date={date}
          defaultDate={defaultDate}
          localizer={mLocalizer}
          style={style}
          views={['month', 'week', 'day']}
          defaultView="week"
          events={events}
          onNavigate={onNavigate}
          onView={onView}
          onSelectEvent={onSelectEvent}
          onSelectSlot={onSelectSlot}
          onEventDrop={onEventDrop}
          resizable={false}
          eventPropGetter={eventPropGetter}
          allDayAccessor={allDayAccessor}
          tooltipAccessor={tooltipAccessor}
          allDayMaxRows={view === "week" ? 3 : undefined}
        />
      </div>

      <Dialog
        header="Nový úkol"
        visible={isNewTaskDialogOpen}
        onHide={onNewTaskDialogHide}
        footer={newTaskDialogFooter}
      >
        Jaký úkol chcete vytvořit?
      </Dialog>
    </>
  )
}
